<template>
  <StackItemModal
      :dialog="{}"
      :sheet="{
        blocking: true,
        canSwipeClose: false,
        expandOnContentDrag: false
      }"
      breakpoint="md"
      :actions="actions"
      v-bind="stackComponent.bind"
      v-on="listeners"
      title="Время"
  >
    <ButtonsToggle
        v-model="timeMode"
        :props="{
              class: 'q-px-md q-py-xs col-grow',
              size: '15px',
              unelevated: true,
              dense: false,
            }"
        :props-active="{
              color: 'secondary'
            }"
        :props-inactive="{
              outline: false,
              color: 'grey-3',
              textColor: 'black'
            }"
        :options="timeModes"
        class="flex q-gutter-x-md justify-center no-wrap q-mb-md"
        :show-badge="true"
    />

    <div class="q-py-md">
      <template v-if="timeMode==='nearest'">

        <q-field
            borderless
            class="q-pt-none custom-field"
            label="Дата и время"
            outlined
            reactive-rules
            readonly
            stack-label
        >
          <template v-slot:control>
            <DatetimeView
                :timeAccent="true"
                :value="datetime"
                class="flex q-gutter-xs q-mt-xs q-mb-sm"
            />
          </template>
        </q-field>

      </template>
      <template v-else>
        <div class="row q-col-gutter-md">
          <div class="col-15 col-sm-12">
            <q-select
                v-model="dateValue"
                :options="dateOptions"
                emit-value
                label="Дата"
                outlined
                @update:model-value="onDateUpdate"
                :disable="vorderCalculateRequest.loading"
            />
          </div>
          <div class="col-9 col-sm-12">
            <q-input
                v-model="timeValue"
                type="time"
                label="Время"
                no-error-icon
                outlined
                @update:model-value="onTimeUpdate"
                :disable="vorderCalculateRequest.loading"
            />
          </div>
        </div>
      </template>

      <DeliveryCalcResult
          v-if="!vorderCalculateRequest.loading && calcResult"
          :calc="calcResult"
          class="q-mt-md"
          @selected="onSelectedNearestCalc"
      />

      <JsonViewer
          :value="{
            calcResult,
            deliveryCalculateResultSuccessAndActual,
            showCheckTime
          }"
          v-if="false"
      />
    </div>
  </StackItemModal>
</template>
<script setup lang="ts">
import {useStackComponent} from "@/packages/stack-router/hooks/useStackComponent";
import {useVorderDialog, VOrderDialogProps, vorderDialogPropsDefault} from "./hook";
import {computed, onMounted, ref, watch} from "vue";
import {DeliveryCalculate, MenuItem} from "@/gql/gen";
import dayjs from "dayjs";
import {storeToRefs} from "pinia";
import parseTime from "@/core/util/date/parseTime";
import ButtonsToggle from "@/components/Ui/ButtonsToggle.vue";
import DatetimeView from "@/components/Ui/DatetimeView.vue";
import DeliveryCalcResult from "../DeliveryCalcResult.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useDeliveryStore} from "@/modules/shop/store/delivery";
import {JsonViewer} from "vue3-json-viewer";

const timeModes = [
  {
    label: 'Ближайшее',
    value: 'nearest',
  },
  {
    label: 'Выбранное',
    value: 'custom',
  },
]

const vorderState = useVorderState()
const deliveryStore = useDeliveryStore()

const {deliveryCalculate, vorderCalculateRequest} = deliveryStore
const {
  deliveryCalculateResult,
  deliveryCalculateResultSuccessAndActual,
  deliveryCalculateResultAge,
  nearestAvailableTime
} = storeToRefs(deliveryStore)
const {attrs, deliveryDate: storeDeliveryDate} = storeToRefs(vorderState)

const props = withDefaults(defineProps<VOrderDialogProps>(), {
  ...vorderDialogPropsDefault
})
const {} = props

const stackComponent = useStackComponent(props)


const {
  listeners
} = useVorderDialog(props)

const dateOptions = computed(() => {
  const nowDay = dayjs()
  return Array.from(Array(30).keys()).map((num) => {
    const date = nowDay.add(num, "day").format('DD.MM.YYYY')
    return {
      value: date,
      label: date
    }
  })
})

const dateValue = ref(attrs.value.DATE || dayjs().format('DD.MM.YYYY'))
const timeValue = ref(attrs.value.TIME || dayjs().format('HH:mm'))
const calcResult = ref<DeliveryCalculate | null | undefined>(deliveryCalculateResult.value)
const timeMode = ref(attrs.value.TIME_MODE)
const timeInputChanged = ref(false)
const showCheckTime = ref(true)

onMounted(() => {
  if (storeDeliveryDate.value) {
    if (storeDeliveryDate.value.diff(Date.now(), 'minute') < 120) {
      timeMode.value = 'nearest'
      attrs.value.TIME_MODE = 'nearest'
    }
  }

  if (timeMode.value === 'nearest') {
    if (deliveryCalculateResultAge.value > 60) {
      checkTime()
    }
  }
})

const datetimeStr = computed(() => {
  if (dateValue.value && timeValue.value) {
    return dateValue.value + ' ' + timeValue.value
  }
})

const datetime = computed(() => {
  if (datetimeStr.value) {
    return parseTime(datetimeStr.value, 'datetime', 'dayjs')
  }
})

const onDateUpdate = (value: any) => {
  timeInputChanged.value = true
  showCheckTime.value = true
  calcResult.value = null
  console.log('onDateUpdate')
}

const onTimeUpdate = (value: any) => {
  timeInputChanged.value = true
  showCheckTime.value = true
  calcResult.value = null
  console.log('onTimeUpdate')
}

const checkTime = async () => {

  const time = timeMode.value === 'nearest' ? Math.round(Date.now() / 1000) : datetime.value?.unix()

  if (time) {
    calcResult.value = await deliveryCalculate({
      time: time,
      mode: timeMode.value
    })
    if (calcResult.value?.RES_STATUS === 'success') {
      showCheckTime.value = false
      attrs.value.TIME_MODE = timeMode.value
    } else {
      showCheckTime.value = true
    }
  }

  console.log('check time', time)
}

const actions = computed(() => {
  const res: Partial<MenuItem>[] = []

  if (timeMode.value === 'nearest') {
    if (showCheckTime.value) {
      res.push({
        label: 'Проверить ближайшее время',
        onClick: checkTime,
        loading: vorderCalculateRequest.loading,
        loadingLabel: 'время проверяется'
      })
    }
  } else {
    if (showCheckTime.value) {
      res.push({
        label: 'Проверить выбранное время',
        onClick: checkTime,
        loading: vorderCalculateRequest.loading,
        loadingLabel: 'время проверяется'
      })
    }
  }

  if (!res.length) {
    res.push({
      label: 'Готово',
      onClick: () => {
        stackComponent.stackItem?.close()
      }
    })
  }

  return res
})

const onSelectedNearestCalc = (calc: DeliveryCalculate) => {
  calcResult.value = calc
  showCheckTime.value = false
  attrs.value.TIME_MODE = 'nearest'
}

watch([() => attrs.value.DATE, () => attrs.value.TIME], () => {
  if (attrs.value.DATE && attrs.value.TIME) {
    dateValue.value = attrs.value.DATE
    timeValue.value = attrs.value.TIME
  }
})

watch(timeMode, () => {
  showCheckTime.value = true
  if (vorderCalculateRequest.loading) {
    return;
  }
  if (timeMode.value === 'nearest') {
    if (deliveryCalculateResultAge.value > 120) {
      checkTime()
    }
  }
})

</script>
<style>

</style>
